import { map, sortBy } from 'lodash';
import { IOrderGroup } from '../interfaces/order';

interface IOutput {
    total: number,
    subtotal: number,
    charges: any[],
    totalCharge: number
}

const useOrderTotal = (order_group: IOrderGroup, isCart: boolean): IOutput => {

    let values: IOutput = {
        total: 0,
        subtotal: 0,
        charges: [],
        totalCharge: 0
    };

    let _charges = sortBy(map(order_group?.charges, item => item), 'index')
    let _totalCharge = _charges.find(x => x.index < 0)

    if (isCart) {
        values.total = order_group?.amount || 0
        values.subtotal = order_group?.amount - _totalCharge?.value || 0
    } else {
        if (order_group?.orders?.value?.completed) {
            if (_totalCharge && _totalCharge?.value) {
                values.total = order_group?.orders?.value?.completed + _totalCharge?.value || 0
            } else {
                values.total = order_group?.orders?.value?.completed || 0
            }
        } else {
            values.total = 0
        }
        values.subtotal = order_group?.orders?.value?.completed || 0
    }

    values.charges = _charges.filter(x => (Math.abs(x.value) > 0 && x.index > -1))
    values.totalCharge = _totalCharge

    return values
}

export default useOrderTotal